module.exports = __webpack_public_path__ + "static/media/DSC03537.5fd68f05.JPG";